/********************************************************************************
Filename: np-countup.js
Created: 03 May 2021
Author: Ron Robertson
Description: Realtime counter display from time of load displayed as HH:MM:SS:mm
Usage Example:
<np-countup></np-countup>

Style Variables:
bodyFontColor: The color of the numbers displayed (default is black)
bodyFontSize: The size of the numbers displayed (default is 48px)
bodyFontFamily: The font used for the numbers displayed
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
            #npCountUp{
                color:var(--bodyFontColor, #000000);
                font-size:var(--bodyFontSize,48px);
                font-family:var(--bodyFontFamily);
                display:flex;
                justify-content:center;
            }

        </style>

        <div id="npCountUp">
            <div id="hours"></div>
            <div>:</div>
            <div id="minutes"></div>
            <div>:</div>
            <div id="seconds"></div>
            <div>:</div>
            <div id="milliseconds"></div>

        </div><!--END npCountUp-->
    `;

    class NpCountUp extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            /* bind 'this' to class in the method */
            this.countUpSetTime = this.countUpSetTime.bind(this);

            /* Use the Shadow DOM */
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            /* Reference to DOM Elements */
            this.npCountUp = this.shadowRoot.getElementById("npCountUp");
            this.hours = this.shadowRoot.getElementById("hours");
            this.minutes = this.shadowRoot.getElementById("minutes");
            this.seconds = this.shadowRoot.getElementById("seconds");
            this.milliseconds = this.shadowRoot.getElementById("milliseconds");

            /* Saves when the componenet is initialy loaded */
            this.countFrom = new Date().getTime();

            /* Holds the interval that calls that repeatidly call the function */
            this.intervalTimer;


        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {
            /* Sets the amount of time in milliseconds to update display */
            this.intervalTimer = setInterval(this.countUpSetTime, 100);

        } /* END connectedCallback */

        /* Called when removed from DOM */
        disconnectedCallback() {
            /* Removing interval */
            clearTimeout(this.intervalTimer);
        }



        /* Method */
        countUpSetTime() {
            var now = new Date(),
            timeDifference = (now - this.countFrom); /* difference between now and when page was first loaded */

            var secondsInADay = 60 * 60 * 1000 * 24,
                secondsInAHour = 60 * 60 * 1000;

            var days = Math.floor(timeDifference / (secondsInADay) * 1);
            var hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
            var mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
            var secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);
            var milli = timeDifference;

            this.hours.innerHTML = ('0' + hours).slice(-2);
            this.minutes.innerHTML = ('0' + mins).slice(-2);
            this.seconds.innerHTML = ('0' + secs).slice(-2);
            this.milliseconds.innerHTML = milli.toString().slice(-3,-1);
        }

    } /* END class */

    window.customElements.define('np-countup', NpCountUp);
  })();
